import { render, staticRenderFns } from "./UserDetailsListItem.vue?vue&type=template&id=2dbcfd12&scoped=true"
import script from "./UserDetailsListItem.vue?vue&type=script&lang=js"
export * from "./UserDetailsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbcfd12",
  null
  
)

export default component.exports